<template>
  <div class="flex items-center justify-center">
    <div class="flex flex-wrap gap-base justify-center">
      <div class="max-w-md">
        <slot name="image">
          <img
            src="/assets/notFoundPageBackground.svg"
            alt="error image"
          />
        </slot>
      </div>
      <div class="p-xs max-w-md flex items-center">
        <div class="flex flex-wrap gap-base items-center justify-center md:justify-start">
          <h2
            class="text-center text-3xl font-medium"
            data-test="title">
            <slot name="title">
              {{ $t('screens.errorScreen.title') }}
            </slot>
          </h2>
          <p
            class="md:text-left text-center"
            data-test="message">
            <slot name="message">
              {{ $t('screens.errorScreen.message') }}
            </slot>
          </p>
          <span class="items-center">
            <slot name="cta"></slot>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ErrorScreen',
});
</script>
